import { Component } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { NewsCategoriesRestService } from '../news-categories-rest.service';

@Component({
  selector: 'app-news-categories-list',
  templateUrl: 'news-categories-list.component.html'
})
export class NewsListComponent extends BaseListBComponent<any> {
  tableColumns: IGridTableColumn[] = [
    {
      i18nLabel: 'ui.news.entity.category',
      field: 'name'
    },
    {
      i18nLabel: 'ui.news.entity.createdDate',
      field: 'createdAt'
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(
    this.tableColumns
  );

  constructor(private _newsCategoriesRest: NewsCategoriesRestService) {
    super();
    this.componentId = 'NewsCategoriesListComponent';
    this.headerTitle = 'ui.categories.list.title';
    this.exportFileName = 'user';
    this.exportDocumentTitle = 'ui.news.list.title';
    this.deleteRecordI18nLabel = 'confirm.any.delete.label';
    this.deleteRecordI18nDescription = 'confirm.any.delete.description';
    this.deleteRecordI18nSuccess = 'success.categories.delete';

    this.headerButtons = [
      {
        type: 'custom',
        label: 'ui.categories.list.button.create',
        color: 'primary-outline',
        routerLink: '/news-categories/create'
        // permissions: ['user.create']
      }
    ];
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        const qParams = Object.assign(
          {},
          event.data.qParams,
          qOption,
          this.qParams
        );

        return this._newsCategoriesRest.findAll(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              d.createdAt = moment(d?.createdAt).format('DD MMMM, YYYY');

              return d;
            });
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'deleteRecord',
      handle: event => {
        const newsId = event.data._id;
        return this._newsCategoriesRest.delete(newsId);
      },
      wrapRetryableTask: true,
      wrapLoadingComponentIds: this.componentId,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () =>
        this.page.compHookService.callMultipleHooks([
          'NewsCategoriesListComponent:workflowLoadData'
        ])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }
}
